import { render, staticRenderFns } from "./_payrollDetails.vue?vue&type=template&id=29567880&scoped=true&"
import script from "./_payrollDetails.vue?vue&type=script&lang=js&"
export * from "./_payrollDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29567880",
  null
  
)

export default component.exports